<div
  class="bg-white dark:bg-[var(--color-dark-bg-secondary)]  border border-gray-200 dark:border-gray-700 rounded-xl p-4 cursor-pointer"
  (click)="onOpen?.(chat)">
  <p class="text-sm font-medium text-gray-900 dark:text-white line-clamp-2">
    {{ question }}
  </p>
  <div class="mt-2 flex items-center justify-between">
    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold"
      [ngClass]="agentBadgeClasses">
      {{ agentShortName }}
    </span>
    <span class="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
      {{ dateLabel }}
    </span>
  </div>
</div>